import styled from 'styled-components';

export const Main = styled.main`
  display: flex;
  width: 100%;
  min-height: 100vh;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
